const getPayload = (model) => ({
  ...model,
  amount: (model.interestLevel || '').replace(/£/g, '').replace(/ /g, '').replace(/k/g, '000'),
})

export default (tracker) => ({
  async submit(model) {
    await tracker.track('Investor Form Submitted', getPayload(model))
  },

  async progress(model) {
    await tracker.track('Investor Form Progress', getPayload(model))
  },
})
